export const URL = "https://kindergarten-littlesparrows.com";

export const initialValues = {
  initial_title: "Premier Kindergarten Education - Little Sparrows Belgrade",
  initial_description:
    "Our kindergarten offers an exceptionally comprehensive preschool education, with highly skilled tutors and a unique variety of engaging classes and activities that ensure every child’s growth and development.",
  initial_image: "/homePage/hero.webp",
};

export const pages = [
  {
    route: "/",
    title: "Premier Kindergarten Education - Little Sparrows Belgrade",
    description:
      "Our kindergarten offers an exceptionally comprehensive preschool education, with highly skilled tutors and a unique variety of engaging classes and activities that ensure every child’s growth and development.",
    image: "/homePage/hero.webp",
  },
  {
    route: "/approach",
    title:
      "Foundation for Your Child’s Success – Little Sparrows Belgrade Kindergarten",
    description:
      "Where Education meets Fun Seeing that all children adore going to Little Sparrows kindergarten makes us very proud. Through a series of fun activities, our experienced tutors help them achieve proper development in different fields.We base our program on learning new languages and acquiring key social skills by exploring the universes of art and sports.",
    image: "/homePage/hero.webp",
  },
  // {
  //   route: "/blog",
  //   title:
  //     "Explore Young Sparrows' articles | Quality Education for Children",
  //   description:
  //     "How to Choose the Best Private Primary School for Your Child. The Importance of Early Childhood Education - Setting a Strong Foundation.",
  //   image: "/homePage/hero.webp"
  // },
  {
    route: "/our-program",
    title:
      "Language, Sports & Arts Programs – Little Sparrows Belgrade Kindergarten",
    description:
      "We focus on Growth Our comprehensive approach ensures your child achieves cognitive, social, emotional, spiritual, and physical development during the time spent at Little Sparrows kindergarten. We provide a diverse set of unique and fun activities led by expert tutors, including different languages, sports, and art. LEARN MORE Help your child Develop crucial life skills.",
    image: "/homePage/hero.webp",
  },
  {
    route: "/pricing",
    title: "Transparent Pricing – Little Sparrows Belgrade Kindergarten",
    description:
      "Your Kid Deserves the Best Our packages are carefully designed to ensure the balanced and healthy development of your child. Each of our comprehensive packages enhances your child’s creative and problem-solving abilities. With the help of our regular updates, you will always be aware of the progress your kid is making in different languages, sports.",
    image: "/homePage/hero.webp",
  },
  {
    route: "/nursery",
    title: "Nursery - International kindergarten Little Sparrows Belgrade",
    description:
      "We give parents peace of mind Naturally, you want nothing but the most outstanding care for your child when you’re not around. At Little Sparrows crèche, your little one will be given love and care from our dedicated specialists. Each of them is experienced and carefully vetted, passionate about helping your child take their first.",
    image: "/homePage/hero.webp",
  },
  {
    route: "/enroll",
    title:
      "Enroll Your Child - International kindergarten Little Sparrows Belgrade",
    description:
      "Reserve a spot in just two minutes Enroll your kid in one of the best international kindergartens in Serbia.",
    image: "/homePage/hero.webp",
  },
];
